"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _ChevronRight = _interopRequireDefault(require("@insided/shared/icons/ChevronRight"));

var SuggestedQuestionsRow = function SuggestedQuestionsRow(_ref) {
  var questions = _ref.questions;

  if (!questions || questions.length === 0) {
    return null;
  }

  return (0, _preact.h)("div", {
    className: "live-search-suggested-questions",
    role: "list"
  }, questions.map(function (question) {
    return (0, _preact.h)("a", {
      key: question,
      href: (0, _absoluteUrlRuntime.resolveUrl)("/search?q=".concat(encodeURIComponent(question))),
      className: "live-search-suggested-questions__item",
      role: "listitem"
    }, (0, _preact.h)("span", {
      className: "live-search-suggested-questions__text"
    }, question), (0, _preact.h)(_ChevronRight.default, {
      className: "live-search-suggested-questions__arrow",
      "aria-hidden": "true"
    }));
  }));
};

var _default = SuggestedQuestionsRow;
exports.default = _default;